import React from "react";
import ReactDOM from "react-dom/client";
import AppRoutes from "./Routes.js";
import "./assets/css/material-dashboard-react.css";
import "./assets/css/custom.css";
import "../node_modules/react-grid-layout/css/styles.css";
import "../node_modules/react-resizable/css/styles.css";
import { Provider } from "react-redux";
import { store, history } from "./reduxStore/configureStore";
import { NotificationsProvider } from "./NotificationsProvider";
import { HistoryRouter } from "redux-first-history/rr6";
import SellerRoutes from "./routes/SellerRoutes.js";
import BuyerRoutes from "./routes/BuyerRoutes.js";
import AdminRoutes from "./routes/AdminRoutes.js";
import WebRoutes from "./routes/WebRoutes.js";
import { buyerHistory, buyerStore } from "./BuyerSellerStack/BuyerStack/reduxStore/configureStore.js";
import { sellerHistory, sellerStore } from "./BuyerSellerStack/SellerStack/reduxStore/configureStore.js";

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);
const CROSS_ENV = process.env.REACT_APP_BOOTSTRAP;

const GetStackBasedOnCrossEnv = (store, basename, history, Stack) => {
    return (
        <Provider store={store}>
            <HistoryRouter basename={basename} history={history}>
                <NotificationsProvider />
                <Stack />
            </HistoryRouter>
        </Provider>
    );
};

const RenderRoutes = () => {

    if (CROSS_ENV === 'buyer') {
        return GetStackBasedOnCrossEnv(buyerStore, "/buyer", buyerHistory, BuyerRoutes);
    }

    else if (CROSS_ENV === 'seller') {
        return GetStackBasedOnCrossEnv(sellerStore, "/seller", sellerHistory, SellerRoutes);
    }

    else {
        //Default stack (WHOLE APP)
        return GetStackBasedOnCrossEnv(store, undefined, history, AppRoutes);
    };


    // if (routes === "seller") return <SellerRoutes />;
    // if (routes === "buyer") return <BuyerRoutes />;
    // if (routes === "admin") return <AdminRoutes />;
    // if (routes === "web") return <WebRoutes />;
};

root.render(RenderRoutes());